export default __webpack_public_path__ + "static/media/seshavaham.523c2dcb.png";